import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useAppDispatch } from '../../../../hooks';
import { zigbeeMoveToLevel } from '../../../../actions/zigbee/commands/LevelControl/ZigbeeMoveToLevel';
import { zigbeeMove } from '../../../../actions/zigbee/commands/LevelControl/ZigbeeMove';
import { zigbeeStop } from '../../../../actions/zigbee/commands/LevelControl/ZigbeeStop';
import { zigbeeStep } from '../../../../actions/zigbee/commands/LevelControl/ZigbeeStep';
import { zigbeeMoveToLevelWithOnOff } from '../../../../actions/zigbee/commands/LevelControl/ZigbeeMoveToLevelWithOnOff';
import { zigbeeMoveWithOnOff } from '../../../../actions/zigbee/commands/LevelControl/ZigbeeMoveWithOnOff';
import { zigbeeStepWithOnOff } from '../../../../actions/zigbee/commands/LevelControl/ZigbeeStepWithOnOff';
import { zigbeeStopWithOnOff } from '../../../../actions/zigbee/commands/LevelControl/ZigbeeStopWithOnOff';
import { zigbeeMoveToClosestFrequency } from '../../../../actions/zigbee/commands/LevelControl/ZigbeeMoveToClosestFrequency';
import { CmdArea } from '../../common/CmdArea';
import { OptionalBoolean } from '../../common/OptionalBoolean';
import { Number } from '../../common/Number';
const UpDown = (props) => {
    return (_jsxs(React.Fragment, { children: [_jsxs("label", { children: [_jsx("input", { type: "radio", name: "updown", value: "up", checked: props.value === 'up', onChange: _ => props.setValue('up') }), "Up"] }), _jsxs("label", { children: [_jsx("input", { type: "radio", name: "updown", value: "down", checked: props.value === 'down', onChange: _ => props.setValue('down') }), "Down"] })] }));
};
const CmdMoveToLevel = (props) => {
    const [level, setLevel] = useState(0);
    const [transitionTime, setTransitionTime] = useState(0);
    const [executeIfOff, setExecuteIfOff] = useState(null);
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeMoveToLevel(props.nid, props.eid, { level, transitionTime, executeIfOff }));
    };
    return (_jsxs(CmdArea, { children: [_jsxs("label", { children: ["Level ", _jsx(Number, { value: level, setValue: setLevel })] }), _jsx("br", {}), _jsxs("label", { children: ["Transition time ", _jsx(Number, { value: transitionTime, setValue: setTransitionTime })] }), _jsx("br", {}), "Execute if off ", _jsx(OptionalBoolean, { value: executeIfOff, setValue: setExecuteIfOff }), _jsx("br", {}), _jsx("button", { onClick: onClick, children: "Move to level" })] }));
};
const CmdMove = (props) => {
    const [mode, setMode] = useState('up');
    const [rate, setRate] = useState(0);
    const [executeIfOff, setExecuteIfOff] = useState(null);
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeMove(props.nid, props.eid, { mode, rate, executeIfOff }));
    };
    return (_jsxs(CmdArea, { children: [_jsxs("label", { children: ["Mode ", _jsx(UpDown, { value: mode, setValue: setMode })] }), _jsx("br", {}), _jsxs("label", { children: ["Rate ", _jsx(Number, { value: rate, setValue: setRate })] }), _jsx("br", {}), "Execute if off ", _jsx(OptionalBoolean, { value: executeIfOff, setValue: setExecuteIfOff }), _jsx("br", {}), _jsx("button", { onClick: onClick, children: "Move" })] }));
};
const CmdStep = (props) => {
    const [mode, setMode] = useState('up');
    const [size, setSize] = useState(0);
    const [transitionTime, setTransitionTime] = useState(0);
    const [executeIfOff, setExecuteIfOff] = useState(null);
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeStep(props.nid, props.eid, { mode, size, transitionTime, executeIfOff }));
    };
    return (_jsxs(CmdArea, { children: [_jsxs("label", { children: ["Mode ", _jsx(UpDown, { value: mode, setValue: setMode })] }), _jsx("br", {}), _jsxs("label", { children: ["Size ", _jsx(Number, { value: size, setValue: setSize })] }), _jsx("br", {}), _jsxs("label", { children: ["Transition time ", _jsx(Number, { value: transitionTime, setValue: setTransitionTime })] }), _jsx("br", {}), "Execute if off ", _jsx(OptionalBoolean, { value: executeIfOff, setValue: setExecuteIfOff }), _jsx("br", {}), _jsx("button", { onClick: onClick, children: "Step" })] }));
};
const CmdStop = (props) => {
    const [executeIfOff, setExecuteIfOff] = useState(null);
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeStop(props.nid, props.eid, { executeIfOff }));
    };
    return (_jsxs(CmdArea, { children: ["Execute if off ", _jsx(OptionalBoolean, { value: executeIfOff, setValue: setExecuteIfOff }), _jsx("br", {}), _jsx("button", { onClick: onClick, children: "Stop" })] }));
};
const CmdMoveToLevelWithOnOff = (props) => {
    const [level, setLevel] = useState(0);
    const [transitionTime, setTransitionTime] = useState(0);
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeMoveToLevelWithOnOff(props.nid, props.eid, { level, transitionTime }));
    };
    return (_jsxs(CmdArea, { children: [_jsxs("label", { children: ["Level ", _jsx(Number, { value: level, setValue: setLevel })] }), _jsx("br", {}), _jsxs("label", { children: ["Transition time ", _jsx(Number, { value: transitionTime, setValue: setTransitionTime })] }), _jsx("br", {}), _jsx("button", { onClick: onClick, children: "Move to level (with on/off)" })] }));
};
const CmdMoveWithOnOff = (props) => {
    const [mode, setMode] = useState('up');
    const [rate, setRate] = useState(0);
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeMoveWithOnOff(props.nid, props.eid, { mode, rate }));
    };
    return (_jsxs(CmdArea, { children: [_jsxs("label", { children: ["Mode ", _jsx(UpDown, { value: mode, setValue: setMode })] }), _jsx("br", {}), _jsxs("label", { children: ["Rate ", _jsx(Number, { value: rate, setValue: setRate })] }), _jsx("br", {}), _jsx("button", { onClick: onClick, children: "Move (with on/off)" })] }));
};
const CmdStepWithOnOff = (props) => {
    const [mode, setMode] = useState('up');
    const [size, setSize] = useState(0);
    const [transitionTime, setTransitionTime] = useState(0);
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeStepWithOnOff(props.nid, props.eid, { mode, size, transitionTime }));
    };
    return (_jsxs(CmdArea, { children: [_jsxs("label", { children: ["Mode ", _jsx(UpDown, { value: mode, setValue: setMode })] }), _jsx("br", {}), _jsxs("label", { children: ["Size ", _jsx(Number, { value: size, setValue: setSize })] }), _jsx("br", {}), _jsxs("label", { children: ["Transition time ", _jsx(Number, { value: transitionTime, setValue: setTransitionTime })] }), _jsx("br", {}), _jsx("button", { onClick: onClick, children: "Step (with on/off)" })] }));
};
const CmdStopWithOnOff = (props) => {
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeStopWithOnOff(props.nid, props.eid));
    };
    return (_jsx(CmdArea, { children: _jsx("button", { onClick: onClick, children: "Stop (with on/off)" }) }));
};
const CmdMoveToClosestFrequency = (props) => {
    const [frequency, setFrequency] = useState(0);
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeMoveToClosestFrequency(props.nid, props.eid, { frequency }));
    };
    return (_jsxs(CmdArea, { children: [_jsxs("label", { children: ["Frequency ", _jsx(Number, { value: frequency, setValue: setFrequency })] }), _jsx("br", {}), _jsx("button", { onClick: onClick, children: "Move to Closest Frequency" })] }));
};
export const CommandsLevel = props => {
    return (_jsx(React.Fragment, { children: _jsxs("div", { style: { display: 'flex', flexWrap: 'wrap', gap: '1em' }, children: [_jsx(CmdMoveToLevel, Object.assign({}, props)), _jsx(CmdMove, Object.assign({}, props)), _jsx(CmdStep, Object.assign({}, props)), _jsx(CmdStop, Object.assign({}, props)), _jsx(CmdMoveToLevelWithOnOff, Object.assign({}, props)), _jsx(CmdMoveWithOnOff, Object.assign({}, props)), _jsx(CmdStepWithOnOff, Object.assign({}, props)), _jsx(CmdStopWithOnOff, Object.assign({}, props)), _jsx(CmdMoveToClosestFrequency, Object.assign({}, props))] }) }));
};
